import { render, staticRenderFns } from "./evaluationResult.vue?vue&type=template&id=071763c6&scoped=true&"
import script from "./evaluationResult.vue?vue&type=script&lang=js&"
export * from "./evaluationResult.vue?vue&type=script&lang=js&"
import style0 from "./evaluationResult.vue?vue&type=style&index=0&id=071763c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071763c6",
  null
  
)

export default component.exports